import ReactGA from "react-ga4";
import { getConsent } from "../providers/ConsentProvider";

/**
 * Track a pageview (respects analytics consent)
 */
export function trackPageview(title: string) {
  const consent = getConsent();
  if (consent?.analytics) {
    ReactGA.send({ hitType: "pageview", title });
  }
}

/**
 * Track an analytics event (respects user consent preferences)
 *
 * - Analytics consent required for: Google Analytics
 * - Marketing consent required for: Reddit Pixel, Meta Pixel
 */
export function trackEvent(event: string) {
  const consent = getConsent();

  // Only track analytics if user has given consent
  if (consent?.analytics) {
    ReactGA.event(event);
  }

  // Only track marketing pixels if user has given consent
  if (!import.meta.env.DEV && consent?.marketing) {
    if (typeof rdt === "function") {
      rdt("track", "Custom", { customEventName: event });
    }
    if (typeof fbq === "function") {
      fbq("trackCustom", event);
    }
  }
}

/**
 * Track a Reddit-specific event (respects marketing consent)
 */
export function trackRedditEvent(event: string) {
  const consent = getConsent();

  if (!import.meta.env.DEV && consent?.marketing) {
    if (typeof rdt === "function") {
      rdt("track", "Custom", { customEventName: event });
    }
  }
}
